import React from "react";
import styles from './RatingComponentGenAi.module.css';
import { OverlayTrigger, Tooltip } from "react-bootstrap";


export default function RatingComponentGenAi({ rating }) {

	const renderTooltip = (props) => (
		<Tooltip {...props} className={styles.tooltipratings}>
			<span className={styles.ratingInfoGlobal}>
				<p style={{ color: "black" }}>Seeker Rating</p>
				<div
					style={{ textAlign: "center", color: "#949494", fontSize: "12px" }}
				>
					&nbsp;
					<span>
						{/* {rating.overallRating === null
							? 0
							: rating.overallRating.toFixed(1)} */}
						{rating}
					</span>
					<span>/5</span>
				</div>
				<div style={{ display: "flex", justifyContent: "center" }}>
					<div
						className="progress"
						style={{
							width: "90%",
							textAlign: "center",
							height: "10px",
							borderRadius: "2px",
						}}
					>
						<div
							className="progress-bar progress-bar-warning"
							role="progressbar"
							aria-valuemin="0"
							aria-valuemax="5"
							style={{
								// width: ratingPercentage("1"),
								width:rating/5 * 100,
								backgroundColor: rating === 1 ? "#ed260c": rating === 2 || 3 || 4 ? '#fead02': rating === 5 ? '#61d937' : null,
							}}
						></div>
						{/* <div
							className="progress-bar progress-bar-warning"
							role="progressbar"
							aria-valuemin="0"
							aria-valuemax="5"
							style={{
								width: rating,
								backgroundColor: "#fead02",
							}}
						></div> */}
						{/* <div
							className="progress-bar progress-bar-warning"
							role="progressbar"
							aria-valuemin="0"
							aria-valuemax="5"
							style={{
								width: rating,
								backgroundColor: "#61d937",
							}}
						></div> */}
					</div>
				</div>
				<div
					style={{
						textAlign: "center",
						color: "#949494",
						fontSize: "12px",
						marginBottom: "5px",
						marginTop: "5px",
					}}
				>
					{/* <span>
						{rating.globalRatings == null ? 0 : rating.globalRatings} global
						ratings
						 global
						ratings
					</span> */}
				</div>
				<br />
			</span>
		</Tooltip>
	);

	const ratingPercentage = (ratingClass) => {
		if (rating.percentage === null) {
			return `0%`;
		}
		if (ratingClass === "1") {
			return rating.percentage["1"] === undefined
				? "0%"
				: `${rating.percentage["1"]}%`;
		}
		if (ratingClass === "4") {
			let star2 =
				rating.percentage["2"] === undefined || rating.percentage["2"] === null
					? 0
					: parseInt(rating.percentage["2"]);
			let star3 =
				rating.percentage["3"] === undefined || rating.percentage["3"] === null
					? 0
					: parseInt(rating.percentage["3"]);
			let star4 =
				rating.percentage["4"] === undefined || rating.percentage["4"] === null
					? 0
					: parseInt(rating.percentage["4"]);
			let allStar = star2 + star3 + star4;
			return `${allStar}%`;
		}
		if (ratingClass === "5") {
			return rating.percentage["5"] === undefined ||
				rating.percentage["5"] === null
				? "0%"
				: `${rating.percentage["5"]}%`;
		}
	};

	return (
		<>
			<OverlayTrigger placement="bottom" overlay={renderTooltip}>
				<div className={styles.ratingDiv}>
					<span
						className={styles.thumbsDown}
						// onClick={CURRENT_ROLE === 'CM' ? null : () => onClickThumbs(1)}
						style={{ color: rating === 1 ? "red" : null }}
					>
						<i className="fa fa-solid fa-thumbs-down fa-border-all"></i>
					</span>
					<span
						className={styles.thumbsUp}
						// onClick={CURRENT_ROLE === 'CM' ? null : () => onClickThumbs(4)}
						style={{
							color:
								rating === 2 || rating === 3 || rating === 4
									? "#ffa500"
									: null,
						}}
					>
						<i className="fa fa-solid fa-thumbs-up fa-border-all"></i>
					</span>
					&nbsp;&nbsp;
					<span
						className={styles.thumbsDoubleUp}
						// onClick={CURRENT_ROLE === 'CM' ? null : () => onClickThumbs(5)}
						style={{ color: rating === 5 ? "#A4BE7B" : null }}
					>
						<i
							className="fa fa-solid fa-thumbs-up"
							style={{
								transform: "rotate(16deg)",
								marginRight: "-10px",
								zIndex: 1000,
								left: "9px",
								marginLeft: "-7px",
							}}
						></i>
						<i className="fa fa-solid fa-thumbs-up"></i>
					</span>
				</div>
			</OverlayTrigger>
		</>
	)
}